import { render, staticRenderFns } from "./VaSlider.vue?vue&type=template&id=41ae7cae&"
import script from "./VaSlider.vue?vue&type=script&lang=js&"
export * from "./VaSlider.vue?vue&type=script&lang=js&"
import style0 from "./VaSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports